module.exports = __webpack_public_path__ + "media/components/assets/bulb-tooltip-63ab1530e42998edcc3efdfa0f61b695.svg";